import dayjs from 'dayjs'
import {
  PARKING_FILTER_TYPES
} from '@/config/constants';

import { filter, first, last } from 'lodash'

export default {
  methods : {
    addSpace(num) {
      if (!num) return "";
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatDate(date, format) {
      if (!date) return '';

      return dayjs(date).format(format);
    },

    unpaid(invoice) {
      return invoice && (invoice.PaymentStatus == "unpaid");
    },
    expired(invoice) {
      return invoice && (dayjs(invoice.ExpireDate).isBefore(dayjs()));
    },
    isCar() {
      return (
        PARKING_FILTER_TYPES['CAR'].includes(this.rentalObject?.realEstateObjectTypeCode) ||
        PARKING_FILTER_TYPES['CAR'].includes(this.rentalObject?.rentalObjectType)
      );
    },
  }
}
